import { useLocalization } from '@/contexts/LocalizationContext'
import { SentryTestButton } from '@/components/common/SentryTestButton'

export function AccountSettingsPage() {
  const { t } = useLocalization()
  return (
    <div className="container mx-auto px-4 py-4 sm:py-6">
      <h1 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6">{t('settings.accountSettings')}</h1>
      <p className="text-sm sm:text-base text-muted-foreground mb-4 sm:mb-6">{t('settings.accountSettingsMessage')}</p>

      {import.meta.env.DEV && (
        <section className="mt-8 rounded-lg border border-dashed border-gray-300 bg-gray-50 p-4">
          <h2 className="text-sm font-semibold text-gray-600 mb-2">Developer — Sentry test</h2>
          <p className="text-xs text-gray-500 mb-2">
            Use these buttons to verify Sentry error tracking. Only visible in development.
          </p>
          <SentryTestButton />
        </section>
      )}
    </div>
  )
}
